<template>
  <v-app style="background-color:white">
    <v-card class="pa-3" elevation="0">
      <div>
        <v-layout wrap row pa-3>
          <v-flex xs6>
            <img :src="require('../assets/logo.png')" height="50" />
          </v-flex>
          <v-flex xs6 text-xs-right>
            <div class="text-xs-left" style="display: inline-block">
              <div class="caption" style="font-family: Kanit">ยอดชำระรวม</div>
              <div class="title" style="font-family: Kanit">
                <b>{{ outstanding }} THB</b>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <v-flex pb-3 :class="{ 'px-3 ': $vuetify.breakpoint.smAndUp }">
          <v-divider></v-divider>
        </v-flex>
      </div>

      <v-flex pt-4 mb-5>
        <div
          class="font-weight-light"
          style="font-size: 18px; font-family: Kanit"
        >
          คุณมียอดค้างชำระ สามารถชำระได้ที่
          <router-link
            :to="route"
            style="overflow-wrap: break-word;word-wrap: break-word"
          >
            www.bangkokhospital.com/payment/1455577BN
          </router-link>
        </div>
      </v-flex>

      <v-flex>
        <v-icon medium color="red">info</v-icon>
        <span class="body-1" style="color: red">
          &nbsp;กรุณาชำระเงินให้ครบภายใน วันที่ {{ expired }}
        </span>
      </v-flex>
    </v-card>
  </v-app>
</template>

<script>
export default {
  computed: {
    outstanding() {
      return this.$store.state.outstanding
    },
    expired() {
      if (this.$store.state.language == 'EN') {
        return this.$store.state.expireDateTimeEn
      } else {
        return this.$store.state.expireDateTimeTh
      }
    },
    route() {
      let page = '/'
      if (this.$store.state.ref2) {
        page = '/authen'
      } else {
        sessionStorage.setItem('linkcode', this.$route.query.linkcode)
        if (
          this.$store.state.billData.status &&
          this.$store.state.billData.status > 3 &&
          this.$store.state.billData.total == this.$store.state.billData.paid
        ) {
          page = '/billRecieve'
        } else {
          page = '/paymentMethods'
        }
      }
      return page + `/?linkcode=${this.$route.query.linkcode}`
    }
  }
}
</script>
